/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
import React, { useRef } from 'react'
import styled from 'styled-components'
import path from 'path'
import localeToDate from 'constants/localeToDate'

import { EditorialPromoList } from 'components/EditorialPromo'
import Accordion from 'components/Accordion'
import ArticleList from 'components/ArticleList'
import ArticleQuote from 'components/Article/ArticleQuote'
import ArticleText from 'components/Article/ArticleText'
import Bambuser from 'components/Bambuser'
import BrandDirectoryWrap from 'components/BrandDirectory/BrandDirectoryWrap'
import BrandTicker from 'components/BrandTicker'
import BulletList from 'components/BulletList'
import ButtonPromo from 'components/ButtonPromo'
import Carousel from 'components/Carousel'
import Contact from 'components/Contact'
import ContactDetails from 'components/ContactDetails'
import CtaHeading from 'components/CtaHeading'
import EventDetail from 'components/EventDetail'
import EventPromo from 'components/EventPromo'
import HomeGrid from 'components/HomeGrid'
import Image from 'components/Image'
import Listicle from 'components/Listicle'
import Mappedin from 'components/Mappedin'
import MembersBenefits from 'components/MembersBenefits'
import { DinePromo } from 'components/MemorableDays'
import OffersGrid from 'components/OffersGrid'
import Partners from 'components/Partners'
import PDFList from 'components/PDFList'
import PortraitGrid from 'components/PortraitGrid'
import ProductGrid from 'components/ProductGrid'
import PromoGrid from 'components/PromoGrid'
import SectionHeader from 'components/SectionHeader'
import SinglePromoCard from 'components/SinglePromoCard'
import Steps from 'components/Steps'
import Tabs from 'components/Tabs'
import VideoPlayer from 'components/VideoPlayer'
import VillageGrid from 'components/VillageGrid'
import VirtualServices from 'components/VirtualServices'
import GiftGuidesProducts from 'components/GiftGuidesProducts'
import BrandContactMethods from 'components/BrandContactMethods'
import LifestyleSubstory from 'components/LifestyleSubstory'
import SocialLinks from 'components/SocialLinks'
import RelatedArticles from 'components/RelatedArticles'
import Modal from 'components/Modal'
import WeChatContactModal from 'components/WeChatContactModal'
import { Container, Spacing50 } from 'styles/sharedStyle'
import GiftGuideCategory from 'components/GiftGuideCategory/GiftGuideCategory'
import PartnerServiceOffer from 'components/PartnerServiceOfferSection'
import { ShoppingPackageCard } from 'components/Card/ShoppingPackage'
import { fixAudiences } from './audiences'
import getContactMethods from './contactMethods'

import { constructUrlPath } from './urlUtils'
import trackGTM from './trackGTM'

const Wrapper = styled.div`
  padding: 20px 0;
`

const MAX_ITEMS_IN_PRODUCT_CAROUSEL = 10

const renderContentTypes = (props, index, pageProps, isEventDetail) => {
  const {
    data: {
      articleLabels,
      eventLabels,
      mapTranslations: {
        edges: [{ node: { slug: mapPageTypeSlug = 'map' } = {} } = {}] = [],
      } = {},
      villages,
    },
    pageContext: {
      nodeLocale,
      villageSlug,
      villageId,
      pageLevel,
      translatedSlugs,
      translatedServices,
    },
  } = pageProps

  const constructUrl = (url, addedVillageSlug) => {
    return constructUrlPath({
      nodeLocale,
      pageLevel,
      translatedServices,
      translatedSlugs,
      url,
      villageSlug: villageSlug || addedVillageSlug,
    })
  }

  const renderEvent = (eventProps) => {
    const {
      headline,
      eyebrow,
      eventPage,
      eventRunStartDate,
      eventRunFinishDate,
      description,
      dateAndTime,
      location,
      eventImages,
      eventRegistrationCTA,
      phoneNumber,
      emailAddress,
      leaseNumber,
    } = eventProps

    const options = { year: 'numeric', month: 'long', day: 'numeric' }

    const translatedEventRunFinishDate = new Date(
      eventRunFinishDate
    ).toLocaleDateString(localeToDate[nodeLocale], options)
    const translatedEventRunStartDate = new Date(
      eventRunStartDate
    ).toLocaleDateString(localeToDate[nodeLocale], options)

    if (isEventDetail) {
      const {
        eventDateTimeHeading,
        eventLocationHeading,
        eventMoreInfoLabel,
        eventPhoneLabel,
        eventEmailLabel,
        eventViewOnMapLabel,
      } = eventLabels
        ? eventLabels.edges[0].node
        : {
            eventDateTimeHeading: '',
            eventLocationHeading: '',
            eventMoreInfoLabel: '',
            eventPhoneLabel: '',
            eventEmailLabel: '',
            eventViewOnMapLabel: '',
          }
      const eventDetailProps = {
        eventRunStartDate: translatedEventRunStartDate,
        eventRunFinishDate: translatedEventRunFinishDate,
        description: description && description.description,
        dateAndTimeHeading: eventDateTimeHeading,
        dateAndTime,
        locationHeading: eventLocationHeading,
        location,
      }
      const contactProps = {
        email: emailAddress,
        emailLabel: eventEmailLabel,
        phone: phoneNumber,
        phoneLabel: eventPhoneLabel,
        title: eventMoreInfoLabel,
        viewMapLabel: eventViewOnMapLabel,
        viewMapUrl:
          leaseNumber &&
          path.join(
            villageSlug || '',
            nodeLocale,
            `${mapPageTypeSlug}#/profile?location=${leaseNumber}`
          ),
      }
      const {
        ctaUrl,
        ...remainingEventRegistrationCTAProps
      } = eventRegistrationCTA || { ctaUrl: '' }

      return (
        <Wrapper key={`eventDetail_${index}`}>
          <EventDetail {...eventDetailProps} />
          {eventImages &&
            eventImages.map((image) => (
              <Image key={`image_${index}`} {...image} type={image.imageType} />
            ))}
          {eventRegistrationCTA && (
            <ButtonPromo
              {...remainingEventRegistrationCTAProps}
              ctaUrl={constructUrl(ctaUrl)}
              background="Grey"
              villageName={
                pageLevel === 'collection'
                  ? 'The Bicester Collection'
                  : pageProps?.data?.page?.village?.name
              }
            />
          )}
          <Contact {...contactProps} />
        </Wrapper>
      )
    }

    const eventSlug =
      eventPage &&
      eventPage[0] &&
      `${eventPage[0].pageType ? `${eventPage[0].pageType.slug}/` : ''}${
        eventPage[0].slug
      }`

    const {
      data: {
        page: { village },
      },
    } = pageProps

    const eventPromoProps = {
      eventImage: eventImages && eventImages.length && eventImages[0].image,
      eventRunStartDate: translatedEventRunStartDate,
      eventRunFinishDate: translatedEventRunFinishDate,
      eventName: headline,
      moreInfoLabel: eyebrow,
      linkUrl: eventSlug ? constructUrl(eventSlug) : '',
      villageSlug,
      villagePlaceholderImage: village?.villagePlaceholderImage,
    }
    return (
      <EventPromo
        {...eventPromoProps}
        key={`eventPromo_${index}`}
        nodeLocale={nodeLocale}
      />
    )
  }

  const productModalContactTitle =
    pageProps?.data?.page?.village?.labels?.[0]?.productModalContactTitle
  switch (props.__typename) {
    case 'ContentfulCompMapMap01': {
      const { mappedinId } = props
      if (!mappedinId) return null
      return (
        <Mappedin
          key={`mappedin-${index.toString()}`}
          village={mappedinId}
          locale={nodeLocale}
        />
      )
    }
    case 'ContentfulCompMapTeaserMap02': {
      const { map, leaseNumber } = props
      if (!map.mappedinId) return null
      return (
        <Mappedin
          key={`mappedin-${index.toString()}`}
          village={map.mappedinId}
          locale={nodeLocale}
          leaseNumber={leaseNumber}
        />
      )
    }
    case 'ContentfulCompButtonPromoInPageBpr02': {
      Object.assign(props, {
        key: `buttonPromo-${index}`,
      })
      const {
        ctaUrl,
        inPage,
        roundTopEdge,
        italicHeadline,
        background,
        external,
        ...remainingProps
      } = props

      return (
        <ButtonPromo
          {...remainingProps}
          ctaUrl={external ? ctaUrl : constructUrl(ctaUrl)}
          external={external}
          inPage={inPage}
          roundTopEdge={roundTopEdge}
          italicHeadline={italicHeadline}
          background={background}
          villageName={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompAccordionAcc01':
      return (
        <Container key={`accordion-${index}`}>
          <Accordion
            {...props}
            villageSlug={
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name
            }
          />
        </Container>
      )

    case 'ContentfulCompSectionHeaderSch01': {
      Object.assign(props, {
        title: props.headline,
        content: props.headerBodyCopy,
        ctaLabel: props.headerCtaLabel,
        ctaUrl: constructUrl(props.headerCtaUrl),
        audiences: fixAudiences(props.audiences),
      })

      return <SectionHeader {...props} key={`section-header-${index}`} />
    }

    case 'ContentfulCompBlockFreeTextBlk02': {
      const { textType, textContent } = props
      const {
        data: { page },
      } = pageProps
      const { pageTemplate } = page || {}
      const centered =
        ['ContentfulPageTemplateMemorableDaysT14'].indexOf(pageTemplate) > -1

      return (
        <ArticleText
          textType={textType}
          centered={centered}
          copy={textContent}
          key={`articleText_${index}`}
        />
      )
    }

    case 'ContentfulCompListicleLis01':
      return <Listicle key={`listicle-${index}`} {...props} />

    case 'ContentfulCompImageImg01':
      return (
        <Image
          key={`image-${index}`}
          {...props}
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
        />
      )

    case 'ContentfulCompQuoteQuo01':
      return <ArticleQuote key={`articleQuote-${index}`} {...props} />

    case 'ContentfulCompCarouselImagesCar04': {
      const hasImagesCarousel = props.items && props.items.length > 0
      const carouselProps = hasImagesCarousel
        ? {
            componentName: props.__typename,
            key: `carouselImageFB-${index}`,
            background: props.background,
            introductionEyebrow: props.eyebrow,
            productModalContactTitle,
            introductionTitle: props.heading,
            introductionContent: props.bodyCopy,
            type: 'normal',
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel: props.items.map((item) => ({
              image: {
                portrait:
                  item.portrait ||
                  (item.videoPlaceholder && item.videoPlaceholder.portrait),
                landscape:
                  item.landscape ||
                  (item.videoPlaceholder && item.videoPlaceholder.landscape),
              },
              video: {
                portrait: item.videoPortrait && item.videoPortrait,
                landscape: item.videoLandscape && item.videoLandscape,
                opacity: item.opacity,
              },
            })),
          }
        : {}
      return hasImagesCarousel && <Carousel {...carouselProps} />
    }

    case 'ContentfulCompCarouselProductsCar06': {
      // Initialize check and temp variables
      const productsAlreadyChecked = []
      let carousel = []

      const {
        data: {
          page: { village },
        },
      } = pageProps
      const {
        data: { labels: villageLabelsList },
      } = pageProps
      const { carouselBrand, filterProductsBy, items, tags } = props

      let villageContactLabels = {}

      if (village && village.labels) {
        ;[villageContactLabels] = village.labels || []
      }

      let villageLabels = {}

      if (
        villageLabelsList &&
        villageLabelsList.edges &&
        villageLabelsList.edges.length > 0
      ) {
        villageLabels = villageLabelsList.edges[0].node
      }

      // make sure tags and items are arrays
      let itemsToProcess = []

      switch (filterProductsBy || 'Products added') {
        case 'Brand':
          if (carouselBrand && carouselBrand.brandId && Array.isArray(items)) {
            items.forEach((item) => {
              if (item.brand?.brandId === carouselBrand.brandId) {
                itemsToProcess.push(item)
              }
            })
          }
          break
        case 'Products added':
          itemsToProcess = !Array.isArray(items) ? [] : [...items]
          break
        case 'Tags':
          if (tags && Array.isArray(items)) {
            const tagsIds = tags.map((tag) => tag.tagId)
            items.forEach((item) => {
              if (
                item.tags &&
                item.tags.find((itemTag) => tagsIds.includes(itemTag.tagId))
              ) {
                itemsToProcess.push(item)
              }
            })
          }
          break
        default:
          itemsToProcess = []
      }

      // iterate through items in carousel
      itemsToProcess.forEach((product) => {
        // is product associated with the same village
        const isSameVillage = product.brand?.village?.villageId === villageId

        // if carousel has a brand association and product is in the
        // same village or carousel doesn't have a brand association and
        // product is in the same village
        if (
          (carouselBrand &&
            carouselBrand.brandId &&
            isSameVillage &&
            product.brand.brandId === carouselBrand.brandId) ||
          (!carouselBrand && isSameVillage)
        ) {
          // checks to prevent iteration needlessly - i.e. products
          // already checked
          if (productsAlreadyChecked.includes(product.productId)) return
          productsAlreadyChecked.push(product.productId)

          const { brandSlug, pageType, village: brandVillage } =
            product.brand || {}
          const { villageSlug: brandVillageSlug } = brandVillage || {}

          const virtualShoppingDetails =
            product?.brand?.content?.find(
              (c) =>
                c.__typename === 'ContentfulCompVirtualShoppingDetailsVsd01'
            ) || {}

          const brandGroupSlug = (pageType || {}).slug || 'brands'

          let formattedBrandLink = ''

          if (brandSlug) {
            // Create BrandLink to be used in Carousel Modals
            formattedBrandLink = path.join(
              '/',
              brandVillageSlug || villageSlug,
              nodeLocale,
              brandGroupSlug,
              brandSlug
            )
          } else {
            formattedBrandLink = path.join(
              '/',
              villageSlug,
              nodeLocale,
              'brands'
            )
          }

          const { pageTypeName } = pageProps.pageContext

          // add product to carousel
          carousel.push({
            date: parseInt(product.date, 10),
            image: product.image,
            moreImages: product.moreImages,
            product: {
              brand:
                product?.productBrandNameOverride || product?.brand?.brandName,
              villageName: product?.brand?.village?.villageName,
              brandLink: formattedBrandLink,
              showBrandLink: !(pageTypeName && pageTypeName === 'brands'),
              virtualShoppingEmail:
                virtualShoppingDetails?.virtualShoppingEmail,
              virtualShoppingPhone:
                virtualShoppingDetails?.virtualShoppingPhone,
              virtualShoppingBookingUrl: virtualShoppingDetails?.bookingUrl,
              virtualShoppingProductCatalogue:
                virtualShoppingDetails?.productCatalogue,
              virtualShoppingWhatsapp: virtualShoppingDetails?.whatsapp,
              description: product.productDescription,
              currency: product?.brand?.village?.currency,
              locale: nodeLocale,
              rrpPrice: product.rrpPrice,
              villagePrice: product.villagePrice,
              salePrice: product.salePrice,
              audiences: product.audiences,
              productTitle: product.title,
              longDescription: product.longDescription
                ? product.longDescription.longDescription
                : '',
              villageLevelLabels: villageContactLabels,
              ...villageLabels,
            },
          })
        }
      })

      // sort items by date and limit to a max of 10 items
      carousel = carousel
        .sort((a, b) => b.date - a.date)
        .slice(0, MAX_ITEMS_IN_PRODUCT_CAROUSEL)

      const hasProductsCarousel = carousel.length > 0

      const carouselProps = hasProductsCarousel
        ? {
            componentName: props.__typename,
            key: `productsCarousel-${index}`,
            background: props.background,
            introductionEyebrow: props.eyebrow,
            introductionTitle: props.heading,
            introductionContent: props.bodyCopy,
            productModalContactTitle,
            type: 'multipleView',
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel,
          }
        : {}

      return (
        hasProductsCarousel && (
          <Carousel
            {...carouselProps}
            componentCallerUID="ContentfulCompCarouselProductsCar06"
            background="white"
            enableImageFadeIn={
              pageProps?.data?.page?.__typename ===
              'ContentfulPageTemplateLifestyleT17'
            }
          />
        )
      )
    }

    case 'ContentfulCompCarouselInfoCardsCar07': {
      const hasInfoCardsCarousel = props.items && props.items.length > 0
      const carouselProps = hasInfoCardsCarousel
        ? {
            componentName: props.__typename,
            key: `infoCardsCarousel-${index}`,
            background: props.background,
            introductionEyebrow: props.eyebrow,
            introductionTitle: props.heading,
            introductionContent: props.bodyCopy,
            productModalContactTitle,
            type: 'multipleView',
            isBoxed: true,
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel: props.items.map((item) => ({
              info: {
                heading: item.heading,
                bodyCopy: item.bodyCopy.childMarkdownRemark.html,
              },
            })),
          }
        : {}

      return hasInfoCardsCarousel && <Carousel {...carouselProps} />
    }

    case 'ContentfulCompCarouselServicesCar08': {
      const hasServicesCarousel = props.items && props.items.length > 0

      const carouselProps = hasServicesCarousel
        ? {
            componentName: props.__typename,
            key: `servicesCarousel-${index}`,
            background: props.background,
            introductionEyebrow: props.eyebrow,
            introductionTitle: props.heading,
            productModalContactTitle,
            introductionContent: props.bodyCopy,
            type: 'multipleView',
            isSmall: true,
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel: props.items.map((item) => ({
              image: item.image,
              service: {
                eyebrow: item.eyebrow,
                heading: item.heading,
                benefit: item.benefit,
                bodyCopy: item.bodyCopy.bodyCopy,
                external: item.external,
                url: item.external
                  ? item.url
                  : path.join(
                      villageSlug,
                      nodeLocale,
                      item.url ? item.url : ''
                    ),
              },
            })),
          }
        : {}

      return hasServicesCarousel && <Carousel {...carouselProps} />
    }

    case 'ContentfulCompPromoCopyCtaPro01Collection': {
      const promoPropsCollection = props.collection.map((promo) => ({
        headline: promo.headline,
        bodyCopy: promo.bodyCopy && promo.bodyCopy.bodyCopy,
        ctaUrl: constructUrl(promo.ctaUrl),
        ctaCopy: promo.ctaCopy,
        image: { image: promo.image },
        audiences: promo.audiences,
      }))
      const promoProps = {
        items: promoPropsCollection,
        key: `editorialPromos-${index}`,
      }

      return <EditorialPromoList {...promoProps} />
    }

    case 'ContentfulCompCarouselFullBleedCar03': {
      const hasArticleCarousel = props.items && props.items.length > 0
      const carouselProps = hasArticleCarousel
        ? {
            componentName: props.__typename,
            key: `carouselArticleFB-${index}`,
            background: props.background,
            introductionEyebrow: props.eyebrow,
            introductionTitle: props.heading,
            productModalContactTitle,
            introductionContent: props.bodyCopy,
            type: 'normal',
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel: props.items
              .filter(
                (item) => item.hero && item.hero.media && item.hero.media[0]
              )
              .map((item) => {
                const media = item.hero.media[0]
                const storyVillageSlug = item.village
                  ? item.village.storyVillageSlug
                  : ''
                const itemArticleIntros =
                  item.articleContent &&
                  item.articleContent.filter(
                    (content) => content.__typename === 'ContentfulArticleIntro'
                  )
                return {
                  article: {
                    heading: item.heading || item.hero.headline,
                    eyebrow: item.category || item.hero.eyebrow,
                    publishDate:
                      itemArticleIntros && itemArticleIntros.length
                        ? itemArticleIntros[0].published
                        : '',
                    url: path.join(
                      storyVillageSlug,
                      nodeLocale,
                      item.pageType ? item.pageType.slug : 'stories',
                      item.slug || ''
                    ),
                  },
                  image: {
                    altText:
                      (media && media.altText) ||
                      (media.videoPlaceholder &&
                        media.videoPlaceholder.altText),
                    portrait:
                      (media && media.portrait) ||
                      (media.videoPlaceholder &&
                        media.videoPlaceholder.portrait),
                    landscape:
                      (media && media.landscape) ||
                      (media.videoPlaceholder &&
                        media.videoPlaceholder.landscape),
                  },
                  video: {
                    portrait: media.videoPortrait && media.videoPortrait,
                    landscape: media.videoLandscape && media.videoLandscape,
                    opacity: media.opacity,
                    name: media.name,
                  },
                }
              }),
          }
        : {}

      return (
        carouselProps &&
        carouselProps.carousel.length > 0 && <Carousel {...carouselProps} />
      )
    }

    case 'ContentfulCompCarouselArticleCar01': {
      const hasArticleCarousel = props.items && props.items.length > 0

      const carouselProps = hasArticleCarousel
        ? {
            componentName: props.__typename,
            key: `carouselArticleMPV-${index}`,
            background: props.background,
            introductionEyebrow: props.eyebrow,
            introductionTitle: props.heading,
            introductionContent: props.bodyCopy,
            productModalContactTitle,
            type: 'multipleView',
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel: props.items
              .filter(
                (item) => item.hero && item.hero.media && item.hero.media[0]
              )
              .map((item) => {
                const media = item.hero.media[0]
                const storyVillageSlug = item.village
                  ? item.village.villageSlug || item.village.storyVillageSlug
                  : ''

                return {
                  article: {
                    heading: item.heading || item.hero.headline,
                    eyebrow: item.eyebrow || item.hero.eyebrow,
                    publishDate: item.published,
                    url: path.join(
                      storyVillageSlug || '',
                      nodeLocale,
                      item.pageType ? item.pageType.slug : 'stories',
                      item.slug
                    ),
                  },
                  image: {
                    altText: media && media.altText,
                    portrait:
                      (media && media.portrait) ||
                      (media.videoPlaceholder &&
                        media.videoPlaceholder.portrait),
                    landscape:
                      (media && media.landscape) ||
                      (media.videoPlaceholder &&
                        media.videoPlaceholder.landscape),
                  },
                }
              }),
          }
        : {}

      if (
        pageProps?.pageResources?.component?.name ===
          'LifestylePageTemplateT17' &&
        pageProps?.pageResources?.json?.data?.page?.pageHexCodeValueTertiary
      ) {
        carouselProps.background = `#${pageProps?.pageResources?.json?.data?.page?.pageHexCodeValueTertiary}`
      }

      return (
        carouselProps &&
        carouselProps.carousel.length > 0 && (
          <Carousel
            {...carouselProps}
            componentCallerUID="ContentfulCompCarouselArticleCar01"
            pageName={pageProps?.pageResources?.component?.name}
          />
        )
      )
    }

    case 'ContentfulCompBlockTextCtaBlk01': {
      const { cta1Url, cta2Url, ...remainingProps } = props
      const textProps = {
        ...remainingProps,
        bodyCopy: props.bodyCopyTextCta || '',
      }
      const audiences = fixAudiences(props.audiences)

      return (
        <Wrapper key={`textBlock-${index}`}>
          <CtaHeading
            {...textProps}
            cta1Url={constructUrl(cta1Url)}
            cta2Url={constructUrl(cta2Url)}
            audiences={audiences}
            villageName={
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name
            }
          />
        </Wrapper>
      )
    }

    case 'ContentfulCompGridHomepageGrd01': {
      const { cards, ...remainingProps } = props
      const cardsWithPath = cards.reduce(
        (newCards, currentCard) =>
          newCards.concat([
            {
              ...currentCard,
              ctaUrl: constructUrl(currentCard.ctaUrl),
            },
          ]),
        []
      )

      return (
        <HomeGrid
          {...remainingProps}
          cards={cardsWithPath}
          key={`grid_${index}`}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompBulletListBul01': {
      const { ctaUrl, ...remainingProps } = props
      return (
        <BulletList
          ctaUrl={constructUrl(ctaUrl)}
          {...remainingProps}
          key={`bulletList_${index}`}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompStepsStp01': {
      const extras = {}
      if (props.qr && props.qr.sizes && props.qr.sizes.src) {
        const {
          description: alt,
          sizes: { src },
        } = props.qr
        extras.qr = { alt, src }
      }
      const stepsProps = Object.assign({}, props, extras)

      return <Steps {...stepsProps} key={`steps_${index}`} />
    }

    case 'ContentfulEntityEventEnt04':
      return renderEvent(props)

    case 'ContentfulCompTabsTab01': {
      const items = props.items
        ? props.items.map((item) => ({
            ...item,
            url: `${item.external ? item.url : constructUrl(item.url)}`,
          }))
        : []

      return (
        <Tabs
          maxWidth={[580]}
          items={items}
          key={`tabs_${index}`}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulPageTemplateEditorialT08Collection': {
      const articleLabelsInstance = articleLabels && articleLabels.edges[0].node
      const pathname = path.join(villageSlug || '', nodeLocale)
      const { collection } = props

      return (
        <ArticleList
          key={`articleList_${index}`}
          articles={collection.map(
            ({
              category,
              publishDate,
              heading,
              slug,
              pageType: articleListPageType,
              hero: {
                headline: heroHeading,
                media: heroMedia,
                eyebrow: heroEyebrow,
              },
            }) => ({
              category: category || heroEyebrow,
              image:
                heroMedia &&
                heroMedia[0] &&
                (heroMedia[0].videoPlaceholder || heroMedia[0]),
              publishDate,
              heading: heading || heroHeading,
              slug,
              articleListPageType,
              villageName:
                pageLevel === 'collection'
                  ? 'The Bicester Collection'
                  : pageProps?.data?.page?.village?.name,
            })
          )}
          eyebrow={articleLabelsInstance && articleLabelsInstance.filterEyebrow}
          header={articleLabelsInstance && articleLabelsInstance.filterHeader}
          loadMore={
            articleLabelsInstance && articleLabelsInstance.loadMoreStoriesCta
          }
          pathname={pathname}
        />
      )
    }

    case 'ContentfulCompGridPartnerCardsGrd06': {
      const partnerProps = Object.assign({}, props, {
        intro: props.intro.intro,
        cards: props.cards
          ? Array.from(props.cards, (card) => {
              return Object.assign({}, card, {
                body: card.body ? card.body.body : undefined,
                image: card.image,
                altText: card.image.altText,
                url: constructUrl(card.url),
              })
            })
          : null,
      })

      return (
        <Partners
          {...partnerProps}
          key={`partners_${index}`}
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
          villageSlug={
            (pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name) ||
            'The Bicester Collection'
          }
        />
      )
    }

    case 'ContentfulCompGridVillagesGrd04': {
      const {
        data: {
          page: { village },
        },
      } = pageProps
      const { name } = village || {}

      if (!villages || !villages.nodes) {
        return null
      }

      const villageGridProps = {
        villageName: name,
        headline: props.headline,
        cards:
          villages && villages.nodes
            ? villages.nodes.map((card) => ({
                ...card,
                url: card.externalVillageLink || card.slug,
                locale: nodeLocale,
              }))
            : [],
      }

      return <VillageGrid {...villageGridProps} />
    }

    case 'ContentfulCompMenuMn01': {
      const pdfListProps = {
        eyebrow: props.eyebrow,
        headline: props.headline,
        items: props.items.map((item) => ({
          text: item.itemName,
          link: (item.media && item.media.file && item.media.file.url) || '#',
        })),
        key: `menu_${index}`,
      }

      return <PDFList {...pdfListProps} />
    }

    case 'ContentfulCompVideoVid01': {
      const {
        name,
        videoPlaceholder,
        videoPortrait,
        videoLandscape,
        opacity,
      } = props
      const placeholderProps = { ...videoPlaceholder }
      const videoProps = {
        portrait: videoPortrait,
        landscape: videoLandscape,
        opacity,
      }
      // Remove padding if on T17 Lifestyle template
      const hasSpacing = !(
        pageProps?.data?.page?.__typename ===
        'ContentfulPageTemplateLifestyleT17'
      )

      return (
        <VideoPlayer
          hasSpacing={hasSpacing}
          name={name || ''}
          image={placeholderProps}
          controls
          isStandalone
          video={videoProps}
          key={`video_${index}`}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }
    case 'ContentfulCompContactDetailsCnt01': {
      const {
        data: {
          page: { village },
        },
      } = pageProps

      const { villageLabelsArray, name } = village || {}

      const [villageLabels] = villageLabelsArray || []
      const villageIcons = {
        whatsapp: villageLabels?.whatsappIcon?.code?.code,
        email: villageLabels?.emailAddressIcon?.code?.code,
        phone: villageLabels?.phoneNumberIcon?.code?.code,
        bookingUrl: villageLabels?.bookingUrlIcon?.code?.code,
      }

      return (
        <ContactDetails
          {...props}
          villageIcons={villageIcons}
          villageName={
            pageLevel === 'collection' ? 'The Bicester Collection' : name
          }
        />
      )
    }

    case 'ContentfulCompLockupProductCardLku02': {
      const {
        data: {
          page: { village },
        },
      } = pageProps
      const { cards } = props

      const { labels: villageLabelsArray } = village || {}

      const [villageLabels] = villageLabelsArray || []

      const productGridProps = cards
        ? props.cards.map((card) => {
            const { brand, productDescription: description } = card
            const brandName = brand ? brand.brandName : ''
            const { brandSlug, pageType, village: brandVillage } =
              card.brand || {}
            const { villageSlug: brandVillageSlug } = brandVillage || {}

            const virtualShoppingDetails =
              card?.brand?.content?.find(
                (c) =>
                  c.__typename === 'ContentfulCompVirtualShoppingDetailsVsd01'
              ) || {}

            const brandGroupSlug = (pageType || {}).slug || 'brands'

            let formattedBrandLink = ''

            if (brandSlug) {
              // Create BrandLink to be used in Carousel Modals
              formattedBrandLink = path.join(
                '/',
                brandVillageSlug || villageSlug,
                nodeLocale,
                brandGroupSlug,
                brandSlug
              )
            } else {
              formattedBrandLink = path.join(
                '/',
                villageSlug,
                nodeLocale,
                'brands'
              )
            }

            const { pageTypeSlug } = pageProps.pageContext

            const contactMethods = []

            if (virtualShoppingDetails && villageLabels) {
              if (
                villageLabels.whatsappLabel &&
                villageLabels.whatsappIcon &&
                virtualShoppingDetails.whatsapp
              ) {
                contactMethods.push({
                  trackLabel: 'WhatsApp Number',
                  icon: villageLabels.whatsappIcon,
                  label: villageLabels.whatsappLabel,
                  contact: `https://wa.me/${virtualShoppingDetails.whatsapp}`,
                })
              }

              if (
                villageLabels.productCatalogueLabel &&
                villageLabels.productCatalogueIcon &&
                virtualShoppingDetails.productCatalogue
              ) {
                contactMethods.push({
                  trackLabel: 'Product Catalogue URL',
                  icon: villageLabels.productCatalogueIcon,
                  label: villageLabels.productCatalogueLabel,
                  contact: virtualShoppingDetails.productCatalogue,
                })
              }

              if (
                villageLabels.bookingUrlLabel &&
                villageLabels.bookingUrlIcon &&
                virtualShoppingDetails.bookingUrl
              ) {
                contactMethods.push({
                  trackLabel: 'Booking URL',
                  icon: villageLabels.bookingUrlIcon,
                  label: villageLabels.bookingUrlLabel,
                  contact: virtualShoppingDetails.bookingUrl,
                })
              }

              if (
                villageLabels.emailAddressLabel &&
                villageLabels.emailAddressIcon &&
                virtualShoppingDetails.virtualShoppingEmail
              ) {
                contactMethods.push({
                  trackLabel: 'Virtual Shopping Email',
                  icon: villageLabels.emailAddressIcon,
                  label: villageLabels.emailAddressLabel,
                  contact: `mailto:${virtualShoppingDetails.virtualShoppingEmail}`,
                })
              }

              if (
                villageLabels.phoneNumberLabel &&
                villageLabels.phoneNumberIcon &&
                virtualShoppingDetails.virtualShoppingPhone
              ) {
                contactMethods.push({
                  trackLabel: 'Virtual Shopping Phone',
                  icon: villageLabels.phoneNumberIcon,
                  label: villageLabels.phoneNumberLabel,
                  contact: `tel:${virtualShoppingDetails.virtualShoppingPhone}`,
                })
              }
            }

            return {
              ...card,
              productModalContactTitle,
              brand: brandName,
              currency: brand?.village?.currency,
              villageName: card?.brand?.village?.villageName,
              description,
              brandLink: formattedBrandLink,
              showBrandLink: pageTypeSlug !== 'brands',
              longDescription: card.longDescription
                ? card.longDescription.longDescription
                : '',
              contactMethods,
              villageLevelLabels: villageLabels,
            }
          })
        : null

      return (
        <ProductGrid
          key={`productGrid_${index}`}
          cards={productGridProps}
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
        />
      )
    }

    case 'ContentfulCompGridOffersGrd03': {
      const { cards, ...remainingProps } = props
      const currentDate = new Date().setHours(12, 0, 0, 0)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }

      const offersGridProps = cards
        ? cards
            .filter((card) =>
              card.offerRunFinishDate
                ? new Date(card.offerRunFinishDate).setHours(12, 0, 0, 0) >=
                  currentDate
                : true
            )
            .sort((card1, card2) => {
              if (card1.featured === card2.featured) {
                return card1.published - card2.published
              }
              return card2.featured - card1.featured
            })
            .map((card) => {
              const media = card.offerImage.media[0]

              let url = constructUrl(card.offerDetailUrl)
              if (card.linkToBrand && card.brand) {
                url = constructUrl(
                  `${card.brand.pageType.slug}/${card.brand.brandSlug}`,
                  card.brand.village.villageSlug
                )
              }

              const translatedOfferRunFinishDate = new Date(
                card.offerRunFinishDate
              ).toLocaleDateString(localeToDate[nodeLocale], options)
              const translatedOfferRunStartDate = new Date(
                card.offerRunStartDate
              ).toLocaleDateString(localeToDate[nodeLocale], options)

              return {
                image: {
                  altText: media && media.altText ? media.altText : '',
                  portrait:
                    media.portrait ||
                    (media.videoPlaceholder && media.videoPlaceholder.portrait),
                  landscape:
                    media.landscape ||
                    (media.videoPlaceholder &&
                      media.videoPlaceholder.landscape),
                },
                offer: {
                  featured: card.featured,
                  eyebrow: card.eyebrow,
                  headline: card.headline,
                  description: card.description.description,
                  offerExpirationLabel: card.offerExpirationLabel,
                  offerRunFinishDate: translatedOfferRunFinishDate,
                  offerRunStartDate: translatedOfferRunStartDate,
                  url,
                  isOfferGrid: true,
                  brandName: card?.brand?.brandName,
                  villageSlug:
                    pageLevel === 'collection'
                      ? 'The Bicester Collection'
                      : pageProps?.data?.page?.village?.name,
                },
              }
            })
        : []
      return <OffersGrid cards={offersGridProps} {...remainingProps} />
    }

    case 'ContentfulLabelBrandListLab03': {
      const {
        data: {
          brands,
          page: {
            search,
            village: { labels: villageLabels, villageSlug: slug, name },
          },
          labels: villageLabelsList,
        },
      } = pageProps
      const { bodyText: bodyCopy } = props

      let villageLabelsComplete = {}

      if (villageLabels && villageLabels.length > 0) {
        villageLabelsComplete = {
          ...villageLabels[0],
        }
      }

      if (
        villageLabelsList &&
        villageLabelsList.edges &&
        villageLabelsList.edges.length > 0
      ) {
        villageLabelsComplete = {
          ...villageLabelsComplete,
          ...villageLabelsList.edges[0].node,
        }
      }

      const labels = {
        bodyCopy,
        ...props,
        villageSlug: slug,
        ...villageLabelsComplete,
      }

      return (
        <BrandDirectoryWrap
          brands={brands}
          villageName={
            pageLevel === 'collection' ? 'The Bicester Collection' : name
          }
          search={search}
          labels={labels}
          key={`brand-directory-${index.toString()}`}
        />
      )
    }

    case 'ContentfulCompCarouselOfferCar05': {
      const {
        bodyCopy,
        ctaCopy,
        ctaUrl,
        eyebrow,
        headline,
        items: propItems,
      } = props
      const { featuredOffers } = pageProps.data

      const currentDate = new Date().setHours(12, 0, 0, 0)
      const options = { year: 'numeric', month: 'long', day: 'numeric' }

      const validOffers = propItems
        ? propItems.filter((card) =>
            card.offerRunFinishDate
              ? new Date(card.offerRunFinishDate).setHours(12, 0, 0, 0) >=
                currentDate
              : true
          )
        : []

      let items = [].concat(
        validOffers,
        featuredOffers ? featuredOffers.nodes : []
      )
      items = items.filter((item, i) => {
        const firstInstance = items.find((obj) => obj.id === item.id)
        return items.indexOf(firstInstance) === i
      })

      const hasOffersCarousel = items && items.length > 0
      const onCtaUrl =
        ctaUrl &&
        pageProps.location.pathname.replace(/^\/|\/$/g, '') ===
          constructUrl(ctaUrl)

      if (!hasOffersCarousel) {
        return null
      }

      const offerCarouselProps = hasOffersCarousel
        ? {
            componentName: props.__typename,
            introductionEyebrow: eyebrow,
            introductionTitle: headline,
            introductionContent: bodyCopy,
            productModalContactTitle,
            isSmall: true,
            type: 'multipleView',
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            cta: onCtaUrl
              ? {}
              : {
                  copy: ctaCopy,
                  url: constructUrl(ctaUrl),
                },
            carousel: items.map((item) => {
              const offerHeroImage =
                item.offerImage &&
                item.offerImage.media &&
                item.offerImage.media[0]

              let altText = ''
              if (offerHeroImage) {
                altText = offerHeroImage.videoPlaceholder
                  ? offerHeroImage.videoPlaceholder.altText
                  : offerHeroImage.altText
              }

              let url = constructUrl(item.offerDetailUrl)
              if (item.linkToBrand && item.brand) {
                url = constructUrl(
                  `${item.brand.pageType.slug}/${item.brand.brandSlug}`,
                  item.brand.village.villageSlug
                )
              }

              const translatedOfferRunFinishDate = new Date(
                item.offerRunFinishDate
              ).toLocaleDateString(localeToDate[nodeLocale], options)
              const translatedOfferRunStartDate = new Date(
                item.offerRunStartDate
              ).toLocaleDateString(localeToDate[nodeLocale], options)

              return {
                image: {
                  altText,
                  portrait:
                    (offerHeroImage && offerHeroImage.portrait) ||
                    (offerHeroImage &&
                      offerHeroImage.videoPlaceholder &&
                      offerHeroImage.videoPlaceholder.portrait),
                  landscape:
                    (offerHeroImage && offerHeroImage.landscape) ||
                    (offerHeroImage &&
                      offerHeroImage.videoPlaceholder &&
                      offerHeroImage.videoPlaceholder.landscape),
                },
                offer: {
                  audiences: item.audiences,
                  featured: item.featured,
                  eyebrow: item.eyebrow,
                  headline: item.headline,
                  componentHeadline: headline,
                  description: item.description && item.description.description,
                  offerExpirationLabel: item.offerExpirationLabel,
                  offerRunFinishDate: translatedOfferRunFinishDate,
                  offerRunStartDate: translatedOfferRunStartDate,
                  url,
                  brandName: item?.brand?.brandName,
                  villageSlug:
                    pageLevel === 'collection'
                      ? 'The Bicester Collection'
                      : pageProps?.data?.page?.village?.name,
                },
              }
            }),
          }
        : {}

      return (
        <Carousel
          {...offerCarouselProps}
          key={`offersCarousel${index.toString()}`}
        />
      )
    }

    case 'ContentfulCompBrandTickerBrd03': {
      const tickerText = Array.from({ length: 3 }, (v, i) => {
        const key = `tickerText${i + 1}`
        return props[key] && props[key][key]
      }).filter((s) => !!s)

      return (
        tickerText.length === 3 && (
          <BrandTicker
            ctaCopy={props.ctaCopy}
            ctaUrl={constructUrl(props.ctaUrl)}
            tickerText={tickerText}
            key={`brandTicker${index.toString()}`}
            villageSlug={
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name
            }
          />
        )
      )
    }

    case 'ContentfulCompGridComboGrd05': {
      const {
        items,
        articleLabel,
        brandLabel,
        dineLabel,
        headline,
        eyebrow,
        loadMoreLabel,
      } = props
      const topPickItems = items.reduce((arr, item) => {
        switch (item.__typename) {
          case 'ContentfulPageTemplateEditorialT08': {
            arr.push({
              ...item.hero,
              slug: item.slug || '',
              publishDate: item.published,
              eyebrow:
                item.hero && item.hero.eyebrow
                  ? item.hero.eyebrow
                  : articleLabel || '',
              pageType: item.pageType,
            })
            break
          }
          case 'ContentfulPageTemplateBrandDetailT06': {
            arr.push({
              ...item.hero,
              slug: item.slug || '',
              headline: item.name,
              eyebrow: brandLabel || '',
              pageType: item.pageType || { slug: 'brands' },
            })
            break
          }
          case 'ContentfulPageTemplateSectionDetailT03': {
            const event = item.content.find(
              (pageContent) =>
                pageContent.__typename === 'ContentfulEntityEventEnt04'
            )
            arr.push({
              ...item.hero,
              publishDate: event ? event.eventRunStartDate : '',
              slug: item.slug || '',
              pageType: item.pageType,
            })
            break
          }
          case 'ContentfulPageTemplateRestaurantDetailT07': {
            arr.push({
              ...item.hero,
              slug: item.slug || '',
              headline: item.name,
              eyebrow: dineLabel || '',
              pageType: item.pageType || { slug: 'dine' },
            })
            break
          }
          case 'ContentfulPageTemplateLifestyleT17': {
            arr.push({
              ...item.hero,
              slug: item.slug || '',
              publishDate: item.published || '',
              headline: item.pageTitle || '',
              eyebrow: item.pageSubtitle || '',
              pageType: item.pageType,
            })
            break
          }
          default:
            break
        }
        return arr
      }, [])

      if (topPickItems.length < 1) {
        return null
      }

      return (
        <ArticleList
          articles={topPickItems.map(
            ({
              headline: itemHeading,
              media: itemMedia,
              eyebrow: itemEyebrow,
              publishDate,
              pageType,
              slug,
            }) => ({
              category: itemEyebrow,
              image:
                itemMedia &&
                itemMedia[0] &&
                (itemMedia[0].videoPlaceholder || itemMedia[0]),
              heading: itemHeading,
              publishDate: publishDate || '',
              pageType,
              slug,
              locale: nodeLocale,
              village: { villageSlug },
              villageName:
                pageLevel === 'collection'
                  ? 'The Bicester Collection'
                  : pageProps?.data?.page?.village?.name,
            })
          )}
          eyebrow={eyebrow}
          header={headline}
          loadMore={loadMoreLabel}
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
        />
      )
    }

    case 'ContentfulCompPortraitGridGrd08': {
      const promos = props.promos.map((item) => {
        const { ctaUrl: propsCtaUrl } = item
        const ctaUrl =
          propsCtaUrl && propsCtaUrl.indexOf('http') !== 0
            ? constructUrl(propsCtaUrl)
            : propsCtaUrl
        return Object.assign({}, item, { ctaUrl })
      })
      const portraitGridProps = Object.assign({}, props, { promos })
      return (
        <PortraitGrid
          {...portraitGridProps}
          key={`portraitGrid${index.toString()}`}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompMultiPromoGridGrd08': {
      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      const { offers = [], ...rest } = props || {}
      const {
        data: {
          page: { village },
        },
      } = pageProps
      const { name } = village || {}
      const formattedOffers = offers.map((offer) => {
        const {
          description: { description } = {},
          offerImage: { media: [media] = [] } = {},
        } = offer || {}
        const {
          altText,
          landscape: landscapeImage,
          videoPlaceholder: { landscape: landscapeVideo } = {},
        } = media || {}
        const image = {
          altText,
          landscape: landscapeImage || landscapeVideo,
        }
        const brandName = offer?.brand?.brandName
        let url = constructUrl(offer.url)
        if (offer.linkToBrand && offer.brand) {
          url = constructUrl(
            `${offer.brand.pageType.slug}/${offer.brand.brandSlug}`,
            offer.brand.village.villageSlug
          )
        }
        const translatedOfferRunFinishDate = new Date(
          offer.offerRunFinishDate
        ).toLocaleDateString(localeToDate[nodeLocale], options)
        const translatedOfferRunStartDate = new Date(
          offer.offerRunStartDate
        ).toLocaleDateString(localeToDate[nodeLocale], options)
        return Object.assign(
          {},
          {
            ...offer,
            offerRunFinishDate: translatedOfferRunFinishDate,
            offerRunStartDate: translatedOfferRunStartDate,
          },
          {
            description,
            image,
            url,
            brandName,
            villageSlug: name,
            componentHeadline: rest.headline,
          }
        )
      })

      return <PromoGrid {...{ offers: formattedOffers, ...rest }} />
    }

    case 'ContentfulCompPromoCardCrd01': {
      const { data: { page: { pageTemplate } = {} } = {} } = pageProps || {}
      const { ctaUrl: propsCtaUrl, ...rest } = props
      const ctaUrl = propsCtaUrl && constructUrl(propsCtaUrl)
      return <SinglePromoCard {...{ ctaUrl, pageTemplate, ...rest }} />
    }

    case 'ContentfulCompCarouselBrandsCar09': {
      const hasItems = props.items && props.items.length > 0
      const carouselProps = hasItems
        ? {
            componentName: props.__typename,
            key: `brandsCarousel-${index}`,
            introductionEyebrow: props.eyebrow,
            introductionTitle: props.heading,
            productModalContactTitle,
            introductionContent: props.introductoryCopy,
            type: 'multipleView',
            image: props.backgroundImage,
            villageName:
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name,
            carousel: props.items.map((item) => ({
              image: item.image,
              brand: {
                eyebrow: item.eyebrow,
                summary: item.summary,
                logo: item.brand.logoImage,
              },
            })),
          }
        : {}
      return hasItems && <Carousel {...carouselProps} />
    }

    case 'ContentfulCompMemDayDineOptionTab02': {
      const { headline, ...rest } = props
      const tab1 = Object.assign(
        {},
        ...Object.keys(rest)
          .filter((key) => key.match(/^tab1/))
          .map((key) => {
            const newKey = key.replace(/^tab1/, '')
            return {
              [newKey]: props[key],
            }
          })
      )
      const tab2 = Object.assign(
        {},
        ...Object.keys(rest)
          .filter((key) => key.match(/^tab2/))
          .map((key) => {
            const newKey = key.replace(/^tab2/, '')
            return {
              [newKey]: props[key],
            }
          })
      )
      tab1.ctaUrl = tab1.ctaUrl && constructUrl(tab1.ctaUrl)
      tab2.ctaUrl = tab2.ctaUrl && constructUrl(tab2.ctaUrl)
      const tabs = [tab1, tab2]
      return (
        <DinePromo
          {...{ headline, tabs }}
          key={`diningPromo${index.toString()}`}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompMemberBenefitsTab02': {
      if (
        props.level1Benefits &&
        props.level2Benefits &&
        props.level3Benefits
      ) {
        return (
          <MembersBenefits
            {...props}
            villageSlug={
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name
            }
          />
        )
      }
      return null
    }

    case 'ContentfulCompVirtualServiceVsp01': {
      const services = props?.services?.map((service) => ({
        title: service.title,
        icon: service.icon.code.code,
        steps: service.steps.map((step) => ({
          title: step.title,
          headline: step.headline,
          description: step.description.description,
        })),
      }))

      return (
        <VirtualServices
          services={services}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompGiftGuideCatGft01': {
      const { id, title, subtitle, calloutImages, products } = props
      const {
        data: {
          page: { village },
        },
      } = pageProps

      const { labels: villageLabelsArray } = village || {}

      const [villageLabels] = villageLabelsArray || []

      const productProps = products.map((product) => {
        const { brandSlug, pageType, village: brandVillage } =
          product.brand || {}
        const { villageSlug: brandVillageSlug } = brandVillage || {}

        const brandGroupSlug = (pageType || {}).slug || 'brands'

        let formattedBrandLink = ''

        if (brandSlug) {
          formattedBrandLink = path.join(
            '/',
            brandVillageSlug || villageSlug,
            nodeLocale,
            brandGroupSlug,
            brandSlug
          )
        } else {
          formattedBrandLink = path.join('/', villageSlug, nodeLocale, 'brands')
        }

        const { pageTypeSlug } = pageProps.pageContext

        return {
          ...product,
          villageName: product?.brand?.village?.villageName,
          brand: product?.productBrandNameOverride || product?.brand?.brandName,
          brandLink: formattedBrandLink,
          showBrandLink: pageTypeSlug !== 'brands',
          description: product.productDescription,
          villageLevelLabels: villageLabels,
          contactMethods: getContactMethods(product, villageLabels),
          productModalContactTitle: villageLabels.productModalContactTitle
            ? villageLabels.productModalContactTitle
            : '',
          currency: product?.brand?.village?.currency,
        }
      })

      const callouts =
        calloutImages &&
        calloutImages.map((item) => {
          if (item.image.__typename === 'ContentfulCompProductPrd01') {
            const product = item.image
            return {
              ...item,
              product: {
                ...item.image,
                brand:
                  product?.productBrandNameOverride ||
                  product?.brand?.brandName,
                description: product.productDescription,
                villageLevelLabels: villageLabels,
                contactMethods: getContactMethods(product, villageLabels),
                productModalContactTitle: villageLabels.productModalContactTitle
                  ? villageLabels.productModalContactTitle
                  : '',
              },
            }
          }
          return item
        })

      return (
        <GiftGuideCategory
          id={id}
          title={title}
          subtitle={subtitle}
          callouts={callouts || []}
          products={productProps}
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompGiftGuideProductsGft02': {
      const { id, title, subtitle, products, hexValue } = props

      const {
        data: {
          page: { village },
        },
      } = pageProps

      const { labels: villageLabelsArray } = village || {}

      const [villageLabels] = villageLabelsArray || []

      const productProps = products.map((product) => {
        const contactMethods = []

        const { brandSlug, pageType, village: brandVillage } =
          product.brand || {}
        const { villageSlug: brandVillageSlug } = brandVillage || {}

        const virtualShoppingDetails =
          product?.brand?.content?.find(
            (c) => c.__typename === 'ContentfulCompVirtualShoppingDetailsVsd01'
          ) || {}

        const brandGroupSlug = (pageType || {}).slug || 'brands'

        let formattedBrandLink = ''

        if (brandSlug) {
          formattedBrandLink = path.join(
            '/',
            brandVillageSlug || villageSlug,
            nodeLocale,
            brandGroupSlug,
            brandSlug
          )
        } else {
          formattedBrandLink = path.join('/', villageSlug, nodeLocale, 'brands')
        }

        const { pageTypeSlug } = pageProps.pageContext

        if (product.brand && villageLabels) {
          if (
            villageLabels.whatsappLabel &&
            villageLabels.whatsappIcon &&
            virtualShoppingDetails.whatsapp
          ) {
            contactMethods.push({
              trackLabel: 'WhatsApp Number',
              icon: villageLabels.whatsappIcon,
              label: villageLabels.whatsappLabel,
              contact: `https://wa.me/${virtualShoppingDetails.whatsapp}`,
            })
          }

          if (
            villageLabels.productCatalogueLabel &&
            villageLabels.productCatalogueIcon &&
            virtualShoppingDetails.productCatalogue
          ) {
            contactMethods.push({
              trackLabel: 'Product Catalogue URL',
              icon: villageLabels.productCatalogueIcon,
              label: villageLabels.productCatalogueLabel,
              contact: virtualShoppingDetails.productCatalogue,
            })
          }

          if (
            villageLabels.bookingUrlLabel &&
            villageLabels.bookingUrlIcon &&
            virtualShoppingDetails.bookingUrl
          ) {
            contactMethods.push({
              trackLabel: 'Booking URL',
              icon: villageLabels.bookingUrlIcon,
              label: villageLabels.bookingUrlLabel,
              contact: virtualShoppingDetails.bookingUrl,
            })
          }

          if (
            villageLabels.emailAddressLabel &&
            villageLabels.emailAddressIcon &&
            virtualShoppingDetails.virtualShoppingEmail
          ) {
            contactMethods.push({
              trackLabel: 'Virtual Shopping Email',
              icon: villageLabels.emailAddressIcon,
              label: villageLabels.emailAddressLabel,
              contact: `mailto:${virtualShoppingDetails.virtualShoppingEmail}`,
            })
          }

          if (
            villageLabels.phoneNumberLabel &&
            villageLabels.phoneNumberIcon &&
            virtualShoppingDetails.virtualShoppingPhone
          ) {
            contactMethods.push({
              trackLabel: 'Virtual Shopping Phone',
              icon: villageLabels.phoneNumberIcon,
              label: villageLabels.phoneNumberLabel,
              contact: `tel:${virtualShoppingDetails.virtualShoppingPhone}`,
            })
          }
        }
        return {
          ...product,
          brandLink: formattedBrandLink,
          showBrandLink: pageTypeSlug !== 'brands',
          description: product.productDescription,
          villageLevelLabels: villageLabels,
          contactMethods,
          productModalContactTitle: villageLabels.productModalContactTitle
            ? villageLabels.productModalContactTitle
            : '',
        }
      })

      // DX-1951: Adding one extra position at the init and end of the array so we can scroll and higlight the first and last card of the carousel
      // This are been ignored if the screensize is less than 900.
      productProps.push({
        ...productProps[productProps.length - 1],
        display: 'none',
      })

      productProps.unshift({
        ...productProps[productProps.length - 1],
        display: 'none',
      })

      return (
        <GiftGuidesProducts
          id={id}
          title={title}
          subtitle={subtitle}
          products={productProps}
          hexValue={pageProps.data.page.hexValue || hexValue}
          villageName={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : village.name
          }
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
        />
      )
    }
    case 'ContentfulCompBrandContactCnt02': {
      const { emailAddress, leaseNumber, phoneNumber } = props

      const {
        data: {
          page: { brandLink, village },
          mapTranslations,
        },
        pageContext,
      } = pageProps

      const labels = (village && village.labels && village.labels[0]) || {}
      const mapPageTypeSlugContact =
        (mapTranslations &&
          mapTranslations.edges &&
          mapTranslations.edges.length &&
          mapTranslations.edges[0].node.slug) ||
        'map'

      return (
        <Contact
          email={emailAddress}
          emailLabel={labels.emailAddressLabel}
          phone={phoneNumber}
          phoneLabel={labels.phoneNumberLabel}
          title={labels.contactDetailsHeader}
          website={brandLink}
          websiteLabel={labels.onlineLabel}
          viewMapLabel={labels.viewOnMapLabel}
          viewMapUrl={
            leaseNumber &&
            path.join(
              village.villageSlug || '',
              pageContext.nodeLocale,
              `${mapPageTypeSlugContact}#/profile?location=${leaseNumber}`
            )
          }
        />
      )
    }

    case 'ContentfulCompVirtualShoppingDetailsVsd01': {
      const {
        virtualShoppingTitle,
        virtualShoppingBody,
        whatsapp,
        productCatalogue,
        bookingUrl,
        virtualShoppingEmail,
        virtualShoppingPhone,
        weChatID,
        weChatImage,
      } = props

      const weChatModalRef = useRef()

      const {
        data: {
          page: { village, name },
        },
      } = pageProps

      const { labels: villageLabelsArray } = village || {}

      const [villageLabels] = villageLabelsArray || []

      const renderContactMethods = () => {
        const methods = []

        if (villageLabels) {
          if (
            whatsapp &&
            villageLabels.whatsappIcon &&
            villageLabels.whatsappIcon.code &&
            villageLabels.whatsappIcon.code.code &&
            villageLabels.whatsappLabel
          ) {
            methods.push({
              trackLabel: 'WhatsApp Number',
              icon: villageLabels.whatsappIcon.code.code,
              label: villageLabels.whatsappLabel,
              link: `https://wa.me/${whatsapp.replace(/\s/g, '')}`,
              showExternalIcon: false,
            })
          }

          if (
            productCatalogue &&
            villageLabels.productCatalogueIcon &&
            villageLabels.productCatalogueIcon.code &&
            villageLabels.productCatalogueIcon.code.code &&
            villageLabels.whatsappLabel
          ) {
            methods.push({
              trackLabel: 'Product Catalogue URL',
              icon: villageLabels.productCatalogueIcon.code.code,
              label: villageLabels.productCatalogueLabel,
              link: productCatalogue,
              showExternalIcon: false,
            })
          }

          if (
            bookingUrl &&
            villageLabels.bookingUrlIcon &&
            villageLabels.bookingUrlIcon.code &&
            villageLabels.bookingUrlIcon.code.code &&
            villageLabels.bookingUrlLabel
          ) {
            methods.push({
              trackLabel: 'Booking URL',
              icon: villageLabels.bookingUrlIcon.code.code,
              label: villageLabels.bookingUrlLabel,
              link: bookingUrl,
              showExternalIcon: false,
            })
          }

          if (
            virtualShoppingEmail &&
            villageLabels.emailAddressIcon &&
            villageLabels.emailAddressIcon.code &&
            villageLabels.emailAddressIcon.code.code &&
            villageLabels.emailAddressLabel
          ) {
            methods.push({
              trackLabel: 'Virtual Shopping Email',
              icon: villageLabels.emailAddressIcon.code.code,
              label: villageLabels.emailAddressLabel,
              link: `mailto:${virtualShoppingEmail}`,
              showExternalIcon: false,
            })
          }

          if (
            virtualShoppingPhone &&
            villageLabels.phoneNumberIcon &&
            villageLabels.phoneNumberIcon.code &&
            villageLabels.phoneNumberIcon.code.code &&
            villageLabels.phoneNumberLabel
          ) {
            methods.push({
              trackLabel: 'Virtual Shopping Phone',
              icon: villageLabels.phoneNumberIcon.code.code,
              label: villageLabels.phoneNumberLabel,
              link: `tel:${virtualShoppingPhone}`,
              showExternalIcon: false,
            })
          }

          if (
            weChatID &&
            villageLabels.weChatIcon &&
            villageLabels.weChatIcon.code &&
            villageLabels.weChatIcon.code.code &&
            villageLabels.weChatLabel
          ) {
            methods.push({
              trackLabel: 'weChat ID',
              icon: villageLabels.weChatIcon.code.code,
              label: villageLabels.weChatLabel,
              link: '',
              showExternalIcon: false,
              onClickCallback: () => weChatModalRef?.current?.openModal(),
            })
          }
        }

        return (
          <BrandContactMethods
            methods={methods}
            brandName={name}
            headerTitle={virtualShoppingTitle}
            villageName={
              pageLevel === 'collection'
                ? 'The Bicester Collection'
                : pageProps?.data?.page?.village?.name
            }
          />
        )
      }

      return (
        !!virtualShoppingTitle && (
          <>
            <Modal ref={weChatModalRef}>
              <WeChatContactModal
                weChatImage={weChatImage}
                weChatID={weChatID}
              />
            </Modal>
            <SectionHeader
              title={virtualShoppingTitle}
              content={virtualShoppingBody}
              withMaxWidth
            />
            {renderContactMethods()}
            <Spacing50 />
          </>
        )
      )
    }

    case 'ContentfulCompLifestyleSubstoryLfs01': {
      const {
        id,
        storyTitle,
        storyDescription,
        image,
        imageTitle,
        product,
        quoteTitle,
        quoteBody,
        featuredProductsTitle,
        featuredProducts,
      } = props

      const {
        data: {
          page: {
            village,
            pageHexCodeValuePrimary,
            pageHexCodeValueTertiary,
            positionFromRightSide,
            content,
          },
        },
      } = pageProps

      const { labels: villageLabelsArray } = village || {}

      const [villageLabels] = villageLabelsArray || []

      const { pageTypeSlug } = pageProps.pageContext

      const productProps = featuredProducts?.map((featuredProduct) => {
        const contactMethods = []

        const { brandSlug, pageType, village: brandVillage } =
          featuredProduct.brand || {}
        const { villageSlug: brandVillageSlug } = brandVillage || {}

        const virtualShoppingDetails =
          featuredProduct?.brand?.content?.find(
            (c) => c.__typename === 'ContentfulCompVirtualShoppingDetailsVsd01'
          ) || {}

        const brandGroupSlug = (pageType || {}).slug || 'brands'

        let formattedBrandLink = ''

        if (brandSlug) {
          formattedBrandLink = path.join(
            '/',
            brandVillageSlug || villageSlug,
            nodeLocale,
            brandGroupSlug,
            brandSlug
          )
        } else {
          formattedBrandLink = path.join('/', villageSlug, nodeLocale, 'brands')
        }

        if (featuredProduct.brand && villageLabels) {
          if (
            villageLabels.whatsappLabel &&
            villageLabels.whatsappIcon &&
            virtualShoppingDetails.whatsapp
          ) {
            contactMethods.push({
              trackLabel: 'WhatsApp Number',
              icon: villageLabels.whatsappIcon,
              label: villageLabels.whatsappLabel,
              contact: `https://wa.me/${virtualShoppingDetails.whatsapp}`,
            })
          }

          if (
            villageLabels.productCatalogueLabel &&
            villageLabels.productCatalogueIcon &&
            virtualShoppingDetails.productCatalogue
          ) {
            contactMethods.push({
              trackLabel: 'Product Catalogue URL',
              icon: villageLabels.productCatalogueIcon,
              label: villageLabels.productCatalogueLabel,
              contact: virtualShoppingDetails.productCatalogue,
            })
          }

          if (
            villageLabels.bookingUrlLabel &&
            villageLabels.bookingUrlIcon &&
            virtualShoppingDetails.bookingUrl
          ) {
            contactMethods.push({
              trackLabel: 'Booking URL',
              icon: villageLabels.bookingUrlIcon,
              label: villageLabels.bookingUrlLabel,
              contact: virtualShoppingDetails.bookingUrl,
            })
          }

          if (
            villageLabels.emailAddressLabel &&
            villageLabels.emailAddressIcon &&
            virtualShoppingDetails.virtualShoppingEmail
          ) {
            contactMethods.push({
              trackLabel: 'Virtual Shopping Email',
              icon: villageLabels.emailAddressIcon,
              label: villageLabels.emailAddressLabel,
              contact: `mailto:${virtualShoppingDetails.virtualShoppingEmail}`,
            })
          }

          if (
            villageLabels.phoneNumberLabel &&
            villageLabels.phoneNumberIcon &&
            virtualShoppingDetails.virtualShoppingPhone
          ) {
            contactMethods.push({
              trackLabel: 'Virtual Shopping Phone',
              icon: villageLabels.phoneNumberIcon,
              label: villageLabels.phoneNumberLabel,
              contact: `tel:${virtualShoppingDetails.virtualShoppingPhone}`,
            })
          }
        }
        return {
          ...featuredProduct,
          brandLink: formattedBrandLink,
          showBrandLink: pageTypeSlug !== 'brands',
          description: featuredProduct.productDescription,
          villageLevelLabels: villageLabels,
          contactMethods,
          productModalContactTitle: villageLabels.productModalContactTitle
            ? villageLabels.productModalContactTitle
            : '',
          currency: village?.currency,
        }
      })

      const { brandSlug, pageType, village: brandVillage } = product.brand || {}
      const { villageSlug: brandVillageSlug } = brandVillage || {}

      const brandGroupSlug = (pageType || {}).slug || 'brands'

      let formattedBrandLink = ''

      if (brandSlug) {
        formattedBrandLink = path.join(
          '/',
          brandVillageSlug || villageSlug,
          nodeLocale,
          brandGroupSlug,
          brandSlug
        )
      } else {
        formattedBrandLink = path.join('/', villageSlug, nodeLocale, 'brands')
      }

      const quoteProductProps = {
        ...product,
        brandLink: formattedBrandLink,
        showBrandLink: pageTypeSlug !== 'brands',
        description: product.productDescription,
        villageLevelLabels: villageLabels,
        contactMethods: getContactMethods(product, villageLabels),
        productModalContactTitle: villageLabels.productModalContactTitle
          ? villageLabels.productModalContactTitle
          : '',
        currency: village?.currency,
      }

      const lifestyleSubstoryComponents = content.filter(
        (item) => item.__typename === 'ContentfulCompLifestyleSubstoryLfs01'
      )
      const lifestyleComponentIndex = lifestyleSubstoryComponents.findIndex(
        (item) => item.id === id
      )

      if (image?.image) {
        // Product component
        image.villageLevelLabels = villageLabels
        image.currency = village?.currency
      }

      return (
        <LifestyleSubstory
          storyTitle={storyTitle}
          storyDescription={storyDescription}
          image={image}
          imageTitle={imageTitle}
          product={quoteProductProps}
          quoteTitle={quoteTitle}
          quoteBody={quoteBody}
          featuredProductsTitle={featuredProductsTitle}
          featuredProducts={productProps}
          hexCodeValue={
            lifestyleComponentIndex % 2 === 0
              ? pageHexCodeValueTertiary
              : pageHexCodeValuePrimary
          }
          positionFromRightSide={
            positionFromRightSide
              ? lifestyleComponentIndex % 2 === 0
              : lifestyleComponentIndex % 2 !== 0
          }
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompSocialMediaLinksSoc01': {
      const {
        facebookLink,
        twitterLink,
        pinterestLink,
        instagramLink,
        youtubeLink,
        tiktokLink,
      } = props

      return (
        <SocialLinks
          facebookLink={facebookLink}
          twitterLink={twitterLink}
          pinterestLink={pinterestLink}
          instagramLink={instagramLink}
          youtubeLink={youtubeLink}
          tiktokLink={tiktokLink}
        />
      )
    }

    case 'ContentfulCompRelatedArticlesArt01': {
      const { title, subtitle, eyebrow, articles } = props

      const carouselProps = articles
        .filter((item) => item.hero && item.hero.media && item.hero.media[0])
        .map((item) => {
          const media = item.hero.media[0]
          const storyVillageSlug = item.village
            ? item.village.villageSlug || item.village.storyVillageSlug
            : ''

          return {
            title: item.heading || item.hero.headline,
            eyebrow: item.hero.eyebrow,
            publishDate: item.published,
            url: path.join(
              storyVillageSlug || '',
              nodeLocale,
              item.pageType ? item.pageType.slug : 'stories',
              item.slug
            ),
            image: {
              altText: media && media.altText,
              portrait:
                (media && media.portrait) ||
                (media.videoPlaceholder && media.videoPlaceholder.portrait),
              landscape:
                (media && media.landscape) ||
                (media.videoPlaceholder && media.videoPlaceholder.landscape),
            },
          }
        })

      return (
        <RelatedArticles
          title={title}
          subtitle={subtitle}
          eyebrow={eyebrow}
          articles={carouselProps}
          enableImageFadeIn={
            pageProps?.data?.page?.__typename ===
            'ContentfulPageTemplateLifestyleT17'
          }
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompBambuserBam01': {
      const { channelId } = props
      return (
        <Bambuser
          channelId={channelId}
          nodeLocale={nodeLocale}
          villageSlug={
            pageLevel === 'collection'
              ? 'The Bicester Collection'
              : pageProps?.data?.page?.village?.name
          }
        />
      )
    }

    case 'ContentfulCompCarouselPartnerSvcCar10': {
      const village =
        pageLevel === 'collection'
          ? 'Bicester Village'
          : pageProps?.data?.page?.village?.name

      return (
        <PartnerServiceOffer
          {...props}
          labels={eventLabels}
          villageName={village}
          allVillages={pageProps?.data?.allVillages ?? []}
        />
      )
    }
    case 'ContentfulCompCardShoppingPackageCsp01': {
      const {
        data: { labels: villageLabelsList },
      } = pageProps

      let villageLabels = {}

      if (
        villageLabelsList &&
        villageLabelsList.edges &&
        villageLabelsList.edges.length > 0
      ) {
        villageLabels = villageLabelsList.edges[0].node
      }

      return (
        <ShoppingPackageCard
          {...props}
          labels={villageLabels}
          villageSlug={villageSlug}
          nodeLocale={nodeLocale}
        />
      )
    }

    default:
      return ''
  }
}

export default (content, props, isEventDetail) => {
  return (
    !!content &&
    content.map((contentProps, index) =>
      renderContentTypes(contentProps, index, props, isEventDetail)
    )
  )
}

trackGTM()
